import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useSearchParams from 'hooks/useSearchParams';
import LoginSection from 'components/order-search-view/login-section/login-section';
import TrackingBanner from 'components/order-search-view/tracking-banner/tracking-banner';
import OrderIDList from 'components/order-search-view/order-id-list/order-id-list';
import OrderInfo from 'components/order-search-view/order-info/order-info';

import TripDuck from 'ducks/trip-duck';
import instrumentationDuck from 'ducks/instrumentation-duck';
import scribeTrack from 'scribe/scribe-track';
import {
  TRACKING_PAGE_TYPE,
  TRACKING_SOURCE,
  URL_PARAMS_MAP_TRACKING_SOURCE,
} from 'scribe/constant';
import { appDataSelector } from 'selectors/app-data-selector';

// eslint-disable-next-line
import styles from './order-search-view.less';

const OrderSearchView = () => {
  const dispatch = useDispatch();
  const TripData = useSelector(TripDuck.selectors.trip);
  const { isExpiredGuid } = useSelector(appDataSelector);
  const [searchParams] = useSearchParams();

  const fromSource = URL_PARAMS_MAP_TRACKING_SOURCE[searchParams.get('src')];

  useEffect(
    () => {
      dispatch(
        instrumentationDuck.creators.updateTrackingInfo({
          orderId: TripData.orderId,
          isExpired: isExpiredGuid,
          trackingPageType: TRACKING_PAGE_TYPE.GUEST_ORDER_SEARCH,
          trackingSource: fromSource || TRACKING_SOURCE.GUEST_ORDER_SEARCH,
        }),
      );
    },
    [TripData.orderId, isExpiredGuid],
  );

  useEffect(() => {
    scribeTrack.expressTracking.default({
      orderIdDisplayed: '',
      isTrackingLinkExpired: '',
      isInApp: false,
      trackingPageType: TRACKING_PAGE_TYPE.GUEST_ORDER_SEARCH,
      trackingSource: fromSource || TRACKING_SOURCE.GUEST_ORDER_SEARCH,
    });
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.toolbar}>
        <LoginSection />
      </div>

      <div className={styles.content}>
        <TrackingBanner />
        <OrderIDList />
        <OrderInfo />
      </div>
    </div>
  );
};

export default OrderSearchView;
